<template>
  <div class="fillcontain">
    <div class="center">
      <div class="lefts" style="background-color: #FFFFFF;box-shadow: 0px 1px 4px 0px  rgba(0, 0, 0, 0.1);">
        <Inboundlisttow :titleList="titleList"></Inboundlisttow>
      </div>
      <div class="contextBox fade">
        <router-view></router-view>
      </div>

    </div>
  </div>
</template>

<script>
import Inboundlisttow from '../../components/Inboundlist-tow.vue'
import { UserInfoMun } from '@/api/home'
export default {
  components: {
    Inboundlisttow,
  },
  data() {
    return {
      titleList: [
        // {
        //   title: "经销商", children: [
        //     { titles: "一级经销商档案", routers: "primarydealerfiles", num: 1 },
        //     { titles: "二级经销商档案", routers: "secondarydealerfiles", num: 2 },
        //   ], childrenboo: false
        // },
        // {
        //   title: "产品", children: [
        //     { titles: "产品线档案", routers: "productlinefile", num: 3 },
        //     { titles: "产品档案", routers: "productfile", num: 4 },
        //   ], childrenboo: false
        // },
        // {
        //   title: "业务", children: [
        //     { titles: "仓库档案", routers: "warehousearchives", num: 5 },
        //     { titles: "医院档案", routers: "hospitalarchives", num: 6 },
        //     { titles: "经销商医院指标维护", routers: "dealerhospitalmaintenanceindicators", num: 7 },
        //     { titles: "销售区域", routers: "salesarea", num: 8 },
        //     { titles: "业务员医院关系", routers: "businesshospitalrelationship", num: 9 },
        //     { titles: "业务员等级", routers: "salesmanlevel", num: 10 },
        //   ], childrenboo: false
        // },
      ],
      titleLists: [],
      onchage: -1
    }
  },
  created() {

  },
  mounted() {
    this.onchage = 0
    setTimeout(() => {
      this.userInfoMun()
    },100)

  },
  computed: {
    defaultActive: function () {
      let index = this.$route.path.replace('/', '')
      // //console.log('路由地址为=' + index)
      return index;
    }
  },
  methods: {
    userInfoMun() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item, index) => {
        if (item.NodeID == 9) {
          this.titleList = item.Nodes
        }
      })
    },
    titlelistclick(index, router) {
      if (index != this.onchage) {
        this.onchage = index
      }
      this.$router.push({ path: router })
    }
  },
   watch:{
     $route: {
          handler(to , from) {
              //console.log(this.$route.query,'quer')
              //console.log(to,'to');
              //深度监听，同时也可监听到param参数变化localhost:8080/#/BA/BaOrganization?MenuID=37&NodeID=9
        },
        deep: true,
    }
    }

}
</script>

<style lang= "less" scoped>
@import "../../style/mixin.less";
.center {
  /* 定宽 */
.zwidth(100%);
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 20px;
}
</style>